module.exports = __webpack_public_path__ + "static/media/Barritas de Frankenstein.221b76f9.webp";